module.exports = __webpack_public_path__ + "static/media/gc-hotel-lobby.00c7f218.png";